import React from 'react';
import ReactDOM from 'react-dom';

import { branch } from 'baobab-react/higher-order';
import * as actions from '../../actions/portalActions';
import * as utils from '../../utils/utils';

import {Link} from 'react-router-dom';

import { Button } from 'react-bootstrap';
import { Panel } from 'react-bootstrap';

import Flexbox from 'flexbox-react';

import { HotKeys } from 'react-hotkeys';

import Alerts from '../app-alerts.js';

import HomeLink from './app-home-link.js';

const keyMap = {
	'verify': 'enter'
}

class VerifyUser extends React.Component {
	submit() {
		var username = ReactDOM.findDOMNode(this.refs.username).value;
		var code = ReactDOM.findDOMNode(this.refs.code).value;

		actions.verifyUser(username, code);
	};

	render() {
		const handlers = {
			'verify': this.submit.bind(this)
		}

		return (
			<HotKeys keyMap={keyMap} handlers={handlers}>
				<Flexbox className="myBackground" flexDirection="column">
					<HomeLink />
					<Flexbox flexDirection="column" alignItems="center" justifyContent="center" flexGrow={1}>
						<Alerts />
						<h3 style={{ color: "#eeeeee", padding: "10px" }}>Check the email you provided for a verification code.</h3>
						<p className="col-xs-10 col-sm-6 col-md-5 col-lg-4" style={{ color: "#eeeeee", padding: "10px" }}>If you don't receive the email in a few minutes check your spam folder. There is a link on the <Link style={{ color: "#0E7AFE" }} to="/portalHome">Sign up</Link> page to resend the verification code or if you are still having issues send an email to <a style={{ color: "#0E7AFE" }} href="mailto:support@miralouaero.com?Subject=No%20Verification%20Code" target="_top">MiraCheck Support</a>.</p>
						<Panel style={{ marginBottom: "5px", padding: "0px" }} className="col-xs-10 col-sm-6 col-md-5 col-lg-4" style={{ overflow: "auto" }}>
							<Panel.Body>
								<div className="row">
									<div className="col-xs-12">
										<label>Username (case-sensitive)</label>
									</div>
									<div className="col-xs-12">
										<input ref="username" style={{ marginBottom: "10px" }} className="form-control" type="text" autoCorrect="off" autoCapitalize="none" defaultValue={this.props.user.username} />
									</div>
									<div className="col-xs-12">
										<label>Verification Code</label>
									</div>
									<div className="col-xs-12">
										<input autoFocus={utils.isMobile()} ref="code" style={{ marginBottom: "5px" }} className="form-control" type="number" defaultValue="" />
									</div>
								</div>
								<Button bsStyle="primary" onClick={this.submit.bind(this)}>Verify</Button>
							</Panel.Body>	
						</Panel>
						<h3 style={{color: "lightgreen", marginTop: "10px"}}>Not registered?</h3>
						<Link style={{ color: "#0E7AFE", fontSize: "16pt" }} to="/portalHome">Sign up</Link>
						<div style={{ color: "white", padding: "20px", textAlign: "center", width: "100%", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
							{this.props.version.copyright}.<br />{this.props.version.prefix}&nbsp;{this.props.version.major}.{this.props.version.minor}.{this.props.version.revision}.{this.props.version.build}&nbsp;{this.props.version.suffix}
						</div>
					</Flexbox>
				</Flexbox>
			</HotKeys>
		);
	}
}

export default branch({
	user: ['user'],
	version: ['version']
}, VerifyUser);

